var React = require('react');

function ArrowTurqouiseInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M37.3555 1.5L46.0638 11L37.3555 20.5","stroke":"#52FFE0","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M46.0624 10.9999L0.9375 11","stroke":"#52FFE0","strokeWidth":"2","key":1})]);
}

ArrowTurqouiseInline.defaultProps = {"width":"48","height":"22","viewBox":"0 0 48 22","fill":"none"};

module.exports = ArrowTurqouiseInline;

ArrowTurqouiseInline.default = ArrowTurqouiseInline;
